import React from 'react'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import styles from './Terms.module.css';
const Terms = () => {
return (
    <>
    <BurgerMenuTitle title="َشرایط و قوانین"/>
    <div className={styles.container}>
        
      <h1 className={styles.title}>شرایط و قوانین استفاده از خدمات برست</h1>
      <div className={styles.meta}>
        <p>تاریخ اجرا: فروردين ١٤٠٣</p>
        <p>نسخه: ۱.۲</p>
        <p>شرکت مالک برند: شرکت تحویل برخط سریع توانا (بَرِست)</p>
        <p>دامنه رسمی: <a href="https://www.barest.ir">www.barest.ir</a></p>
      </div>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۱. معرفی</h2>
        <ul>
          <li>۱-۱. وب‌سایت و اپلیکیشن Barest.ir متعلق به شرکت تحویل برخط سریع توانا است.</li>
          <li>۱-۲. استفاده از هرگونه خدمات این پلتفرم به معنای پذیرش بی‌قید و شرط شرایط و قوانین حاضر تلقی می‌شود.</li>
          <li>۱-۳. کاربران موظف‌اند قبل از استفاده از خدمات، این مقررات را به‌دقت مطالعه نمایند.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۲. تعاریف</h2>
        <ul>
          <li>۲-۱. کاربر: هر شخص حقیقی یا حقوقی که از خدمات تاکسی، پیک، پست یا خرید اینترنتی برست استفاده می‌کند.</li>
          <li>۲-۲. پیک / راننده: فردی که در بستر پلتفرم برست فعالیت حمل و نقل یا جابجایی مسافر انجام می‌دهد.</li>
          <li>۲-۳. تامین‌کننده / فروشگاه: واحد صنفی که از طریق پلتفرم محصولات خود را برای فروش و تحویل عرضه می‌کند.</li>
          <li>۲-۴. حساب کاربری: پروفایلی در بستر برست که به‌منظور استفاده از خدمات ایجاد می‌شود.</li>
          <li>۲-۵. مرسوله / سفر / سفارش: محموله یا خدماتی که از طریق برست ثبت و اجرا می‌شود.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۳. تعهدات کاربران</h2>
        <ul>
          <li>۳-۱. کاربران متعهدند کلیه اطلاعات ثبت‌شده در پلتفرم واقعی و دقیق باشد.</li>
          <li>۳-۲. مسئولیت محتویات مرسوله، از جمله اقلام غیرمجاز، بر عهده ارسال‌کننده است.</li>
          <li>۳-۳. استفاده فقط در چارچوب قوانین جمهوری اسلامی ایران مجاز است.</li>
          <li>۳-۴. رعایت پوشش و رفتار محترمانه با پیک‌ها الزامی است.</li>
          <li>۳-۵. سوءاستفاده از خدمات پیگرد قانونی دارد.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۴. تعهدات شرکت</h2>
        <ul>
          <li>۴-۱. حفظ امنیت و اطلاعات شخصی کاربران.</li>
          <li>۴-۲. عدم مسئولیت بابت تأخیر ناشی از عوامل خارجی.</li>
          <li>۴-۳. حق مسدودسازی حساب در صورت تخلف.</li>
          <li>۴-۴. شرکت مسئول کیفیت کالاها نیست و فقط واسط لجستیکی است.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۵. پرداخت‌ها و بازگشت وجه</h2>
        <ul>
          <li>۵-۱. هزینه‌ها بر اساس نرخ‌نامه رسمی پلتفرم است.</li>
          <li>۵-۲. بازگشت مبلغ فقط به صورت اعتبار غیرقابل برداشت انجام می‌شود.</li>
          <li>۵-۳. در صورت نوسان قیمت:
            <ul>
              <li>۵-۳-۱. افزایش قیمت نیازمند پرداخت مابه‌التفاوت است.</li>
              <li>۵-۳-۲. کاهش قیمت به صورت اعتبار بازگردانده می‌شود.</li>
            </ul>
          </li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۶. حقوق مالکیت معنوی</h2>
        <ul>
          <li>۶-۱. کلیه حقوق متعلق به شرکت تحویل برخط سریع توانا (برست) است.</li>
          <li>۶-۲. کپی‌برداری و استفاده غیرمجاز پیگرد قانونی دارد.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۷. حریم خصوصی و امنیت داده‌ها</h2>
        <ul>
          <li>۷-۱. اطلاعات کاربران محفوظ است و فقط برای خدمات استفاده می‌شود.</li>
          <li>۷-۲. عدم اشتراک‌گذاری اطلاعات با اشخاص ثالث بدون حکم قانونی.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۸. تغییرات در قوانین</h2>
        <ul>
          <li>۸-۱. شرکت می‌تواند در هر زمان قوانین را تغییر دهد.</li>
          <li>۸-۲. ادامه استفاده به معنی پذیرش نسخه جدید است.</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۹. حل اختلاف و مرجع رسیدگی</h2>
        <ul>
          <li>۹-۱. ابتدا تلاش برای حل اختلاف از طریق پشتیبانی داخلی.</li>
          <li>۹-۲. مرجع نهایی، مراجع قضایی جمهوری اسلامی ایران (شهر بهشهر).</li>
        </ul>
      </section>

      <hr className={styles.sectionDivider} />

      <section>
        <h2>۱۰. اطلاعات تماس</h2>
        <p>تلفن پشتیبانی: ٠١١٤٤٤٠٠٧٦٥</p>
        <p>ایمیل رسمی: info@barest.ir</p>
        <p>آدرس شرکت: بهشهر، خ پاسداران، پاسداران ١٤، طبقه همكف</p>
        <p>اینستاگرام: <a href="https://instagram.com/barest.ir">@barest.ir</a></p>
      </section>
    </div>
    </>
  );
}

export default Terms